import { render, staticRenderFns } from "./LaporanPemotongan.vue?vue&type=template&id=53a55974&scoped=true&"
import script from "./LaporanPemotongan.vue?vue&type=script&lang=js&"
export * from "./LaporanPemotongan.vue?vue&type=script&lang=js&"
import style0 from "./LaporanPemotongan.vue?vue&type=style&index=0&id=53a55974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a55974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VSelect,VTextField})
